import eventsApi from './api';

export * from './api';
export default eventsApi;
